import React from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { Button, Grid, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';

import { DateTimeField, Form, NumberTextField, SelectField, useSettings, Utils } from 'app/main/components';

interface DailyReportParametersDialogProps {
	userUid: string;
	userMail: string;
	updateReportDailyEnabledDB;
}

export const showDailyReportParametersDialog = (props: DailyReportParametersDialogProps) =>
	openDialog({
		children: <DailyReportParametersDialog {...props} />,
		fullWidth: true,
		maxWidth: 'sm'
	});

export default function DailyReportParametersDialog({
	userUid,
	userMail,
	updateReportDailyEnabledDB
}: DailyReportParametersDialogProps) {
	const { t } = useSettings();
	const dispatch = useDispatch();
	const applicationFolder = Utils.getConnectionFromToken() === 'PERCEPTIVE_CONTROL_BEB' ? 'BEB' : 'PF';

	const [triggerData, setTriggerData] = React.useState<any>({
		Timezone: 'UTC',
		StartDate: moment(),
		RecurrenceInterval: 1,
		RecurrenceIntervalUnit: 2
	});

	const sendChange = (name, value) => {
		setTriggerData(d => ({ ...d, [name]: value }));
	};

	const sendDailyJobEnable = () => {
		Utils.executeApi.put({
			url: 'api/reporting/jobs',
			body: {
				JobName: `Riepilogo giornaliero - ${userMail}`,
				JobDescription: userUid,
				ReportUri: `/reports/crm/${applicationFolder}/users/riepilogo_scadenze_giornaliero`,
				ReportParameters: {
					FIELD_USER: [userUid],
					BASE_URL: [window.location.origin]
				},
				Trigger: triggerData,
				OutputFileName: 'riepilogo',
				OutputFormats: ['HTML'],
				MailNotification: {
					Subject: `Perceptive.Control - Riepilogo giornaliero ${applicationFolder}`,
					ToAddresses: [userMail]
				}
			},
			dispatch,
			successHandler: response => updateReportDailyEnabledDB(response.data.id)
		});
	};

	return (
		<>
			<DialogTitle>{t('DIALOG_TITLE_DAILY_REPORT_SETTINGS')}</DialogTitle>
			<DialogContent className="py-0">
				<Form id="dailyReportParametersDialog" onSubmit={sendDailyJobEnable}>
					<Grid container spacing={2}>
						<Grid size={12}>
							<DateTimeField
								name="StartDate"
								label={t('DAILY_REPORT_START_DATE')}
								value={triggerData.StartDate}
								sendChange={sendChange}
								isEdit
							/>
						</Grid>
						<Grid size={{ sm: 6, xs: 12 }}>
							<NumberTextField
								name="RecurrenceInterval"
								label={t('DAILY_REPORT_RECURRENCE_INTERVAL')}
								value={triggerData.RecurrenceInterval}
								sendChange={sendChange}
								isEdit
							/>
						</Grid>
						<Grid size={{ sm: 6, xs: 12 }}>
							<SelectField
								name="RecurrenceIntervalUnit"
								label={t('DAILY_REPORT_RECURRENCE_INTERVAL_UNIT')}
								options={[
									{ value: 1, title: t('DAILY_REPORT_UNIT_WEEK') },
									{ value: 2, title: t('DAILY_REPORT_UNIT_DAY') },
									{ value: 3, title: t('DAILY_REPORT_UNIT_HOUR') },
									{ value: 4, title: t('DAILY_REPORT_UNIT_MINUTE') }
								]}
								value={triggerData.RecurrenceIntervalUnit}
								sendChange={sendChange}
								isEdit
								disableEmptyOption
							/>
						</Grid>
					</Grid>
				</Form>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button type="submit" form="dailyReportParametersDialog" color="secondary">
					{t('DIALOG_ACTION_CONFIRM')}
				</Button>
			</DialogActions>
		</>
	);
}
